import { useTranslations } from 'next-intl';

import StarIcon from '@/fo/icons/base/icons/star.svg';

import {
  RatingFilter as RatingFilterType,
  ReviewsData,
  ReviewsFilter
} from '../../types';

import { styles } from './RatingFilter.styles';

const RATING_VALUES = ['5', '4', '3', '2', '1'] as const;

export interface RatingFilterProps {
  filters: ReviewsFilter;
  onChange: (filter: ReviewsFilter) => void;
  reviewsData: ReviewsData;
}

export function RatingFilter({
  filters,
  onChange,
  reviewsData
}: RatingFilterProps) {
  const t = useTranslations();
  const slots = styles();

  const handleRatingClick = (rating: RatingFilterType) => {
    const newSelectedRating = filters.selectedRating === rating ? null : rating;

    onChange({
      ...filters,
      selectedRating: newSelectedRating
    });
  };

  return (
    <div className={slots.base()}>
      <h3 className={slots.title()}>{t('review.filter.rating')}</h3>
      <div className={slots.ratingsContainer()}>
        {RATING_VALUES.map((rating) => {
          const isSelected = filters.selectedRating === rating;

          return (
            <div
              key={rating}
              className={slots.ratingButton()}
              role="button"
              onClick={() => handleRatingClick(rating)}
            >
              <div className={slots.rating()}>
                <div className={slots.ratingValue({ selected: isSelected })}>
                  {rating}
                </div>
                <div className={slots.star()}>
                  <StarIcon />
                </div>
              </div>
              <div className={slots.ratingBar()}>
                <div className={slots.ratingBarLine()} />
                <div
                  className={slots.ratingBarFill()}
                  style={{ width: `${reviewsData.ratingDetails[rating]}%` }}
                />
              </div>
              <div className={slots.count()}>
                {reviewsData.ratingDetails[rating]}%
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
